import React from "react";

const PROFILES = [
    {
        img: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=900&q=80",
        title: "Expert vertical",
        verticals: "Travel · Gaming · Diaspora",
        text: "Travel, gaming, communautaire, diaspora — tu connais un secteur et ses acteurs en profondeur. Tu sais où, comment et à qui parler.",
        tags: ["Travel", "Gaming", "Diaspora"],
    },
    {
        img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=900&q=80",
        title: "Développeur de réseaux",
        verticals: "Franchises · Groupements · Marketplaces",
        text: "Tu as accès à des franchises, groupements, marketplaces ou réseaux B2B structurés. Tu sais les ouvrir et les activer.",
        tags: ["Franchises", "Groupements", "Marketplaces"],
    },
    {
        img: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=900&q=80",
        title: "Opérateur de zone",
        verticals: "Région · Pays · Zone exclusive",
        text: "Tu couvres une région ou un pays que CapDistrib ne gère pas en direct. Tu animes la zone et structures les partenaires sur place.",
        tags: ["Région", "Pays", "Zone exclusive"],
    },
];

export default function Profiles() {
    return (
        <section
            id="profils"
            className="relative py-24 sm:py-32 bg-cap-light overflow-hidden"
            data-testid="profiles-section"
        >
            <div className="absolute inset-0 bg-grid-light opacity-70 pointer-events-none" />
            <div className="absolute -top-32 right-1/4 w-[420px] h-[420px] rounded-full bg-cap-violet/10 blur-[120px]" />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <p className="fade-up eyebrow">Qui cherchons-nous ?</p>
                    <h2
                        className="fade-up h-display text-3xl sm:text-4xl lg:text-[56px] font-bold mt-4 text-cap-ink"
                        style={{ animationDelay: "0.05s" }}
                        data-testid="profiles-title"
                    >
                        CapDistrib s'adresse aux{" "}
                        <span className="text-cap-violet">pros du B2B</span>.
                    </h2>
                    <p
                        className="fade-up mt-6 text-lg text-cap-textMuted leading-relaxed"
                        style={{ animationDelay: "0.1s" }}
                    >
                        Pas de retail, pas de commerces individuels. Des
                        indépendants avec un réseau existant à fort potentiel.
                    </p>
                </div>

                <div className="mt-14 grid md:grid-cols-3 gap-7">
                    {PROFILES.map((p, i) => (
                        <div
                            key={p.title}
                            className="fade-up glass-light p-5 flex flex-col group"
                            style={{ animationDelay: `${0.08 * i + 0.1}s` }}
                            data-testid={`profile-card-${i}`}
                        >
                            <div className="relative h-[260px] sm:h-[280px] rounded-[12px] overflow-hidden">
                                <img
                                    src={p.img}
                                    alt={p.title}
                                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                    loading="lazy"
                                />
                                <div
                                    className="absolute inset-0"
                                    style={{
                                        background:
                                            "linear-gradient(180deg, rgba(10,10,15,0) 55%, rgba(10,10,15,0.55) 100%)",
                                    }}
                                />
                                <span className="absolute top-4 left-4 inline-flex items-center text-[10.5px] uppercase tracking-[0.18em] font-semibold px-2.5 py-1 rounded-full bg-white/95 text-cap-ink">
                                    Profil {String(i + 1).padStart(2, "0")}
                                </span>
                            </div>
                            <div className="px-2 pt-6 pb-3 flex flex-col flex-1">
                                <h3 className="h-display text-[22px] font-semibold text-cap-ink">
                                    {p.title}
                                </h3>
                                <span
                                    className="mt-2 inline-flex self-start items-center text-[11.5px] font-medium px-3 py-1 rounded-full bg-cap-violet/10 text-cap-violet ring-1 ring-cap-violet/20"
                                    data-testid={`profile-vertical-${i}`}
                                >
                                    {p.verticals}
                                </span>
                                <p className="mt-4 text-cap-textMuted leading-relaxed text-[15px]">
                                    {p.text}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
